import { Component, OnInit, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MODAL_DATA } from '@stockaid/services';
import { BaseComponent } from '@stockaid/core';
import { finalize, first, tap } from 'rxjs/operators';
import { downloadFile } from 'src/app/core/utils';
import { SyncService } from 'src/app/core/services/sync.service';
import { PriceUploadError } from './price-upload-error-modal.interface';

@Component({
  selector: 'app-price-upload-error-modal',
  templateUrl: './price-upload-error-modal.component.html',
  styleUrls: ['./price-upload-error-modal.component.scss'],
})
export class PriceUploadErrorModalComponent extends BaseComponent implements OnInit {
  private readonly MAX_DISPLAY_ERRORS = 500;

  errors: PriceUploadError[] = [];
  isGuideCollapsed = true;
  reportLink: string | null = null;
  reportId: string | null = null;
  totalErrorCount = 0;
  totalCount = 0;
  uploadBatchId: string | null = null;
  isLoading = false;
  hintMessage: string | null = null;

  constructor(
    @Inject(MODAL_DATA) public data: { errors?: PriceUploadError[], reportLink?: string, totalErrorCount?: number, totalCount?: number, uploadBatchId?: string },
    public activeModal: NgbActiveModal,
    private syncService: SyncService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.errors = this.data?.errors || [];
    this.reportLink = this.data?.reportLink || null;
    this.totalErrorCount = this.data?.totalErrorCount ?? this.errors.length;
    this.totalCount = this.data?.totalCount ?? 0;
    this.uploadBatchId = this.data?.uploadBatchId ?? null;

    if (this.reportLink) {
      this.reportId = this.reportLink.split('/').pop() ?? null;
    }

    if (this.totalErrorCount > this.errors.length) {
      this.hintMessage = `Showing ${this.errors.length} of ${this.totalErrorCount} errors. Download the full report to see all.`;
    }

    if (this.reportLink && !this.errors.length) {
      this.loadAdditionalErrors();
    }
  }

  private loadAdditionalErrors(): void {
    this.isLoading = true;
    this.syncService.getErrorReport(this.reportLink!, this.reportId!, true).pipe(
      this.autoCleanUp(),
      first(),
      tap((lines: string[]) => {
        this.errors = lines.slice(1, this.MAX_DISPLAY_ERRORS + 1).map((line) => {
          const [csvLine, sku, asin, amazonLink, errorMessage] = line.split(',');
          return {
            sku: sku || '',
            asin: asin || '',
            message: errorMessage || '',
            amazonLink: amazonLink || '',
            lineNumber: Number(csvLine),
          };
        });
        if (this.totalErrorCount > this.MAX_DISPLAY_ERRORS) {
          this.hintMessage = `Showing ${this.MAX_DISPLAY_ERRORS} of ${this.totalErrorCount} errors. Download the full report to see all.`;
        } else {
          this.hintMessage = '';
        }
      }),
      finalize(() => { this.isLoading = false; }),
    ).subscribe();
  }

  downloadErrors(): void {
    downloadFile(this.reportLink!, `price-upload-errors-${this.reportId}.tsv`);
  }

  onClose(): void {
    this.activeModal.close();
  }

  onContinueToReview(): void {
    this.activeModal.close();
  }

  toggleGuide(): void {
    this.isGuideCollapsed = !this.isGuideCollapsed;
  }
}
